export const parseStringOrBoolean = (v?: string | boolean) => typeof v === 'string' ? v === 'true' : !!v